'use strict';

export default {
  itemListUrl: '/authority/dictionaryItem/code',
  provinceUrl: '/authority/dictionaryItem/code/tree',

};
